<template>
   <div id="block_content_wrapper" :class="{feed: isFeed}">

      <!-- Program Block Assets -->
      <program-block-display-assets
         :channelRecid="currActiveChannelRecid"
         :activeOrder="activeOrder"
         :isFeed="isFeed"
         :isGameBlock="isGameBlock"
         :saved="saved"
         :reset="reset"
         @addSlotClicked="$emit('addSlotClicked')"
      ></program-block-display-assets>

      <!-- Right Area -->
      <div class="block-right-col no-padding">
      
         <!-- <expiration-info
            :on="block.c_exp_date != '' && block.c_exp_date != undefined"
            :expDate="block.c_exp_date"
            :expTime="block.c_exp_time"
            @changeExp="updateExp"
         ></expiration-info> -->

         <channel-checks
            :channelRecid="currActiveBlockRecid == -1 ? currActiveChannelRecid : ''"
            :initialSelected="blockChannels"
         ></channel-checks>
         
         <category-checks
            :initialSelected="blockCategories"
         ></category-checks>
         
      </div>

      <div class="block-space">
      </div>

   </div>
</template>

<script>
import ProgramBlockDisplayAssets from './ProgramBlockDisplayAssets';
import CategoryChecks from './../../../../global/CategoryChecks';
import ChannelChecks from './../../../../global/ChannelChecks';
import { mapActions, mapState } from 'vuex';

export default {
   data() {
      return {
         channelRecids: [],
         categoryRecids: [],
      }
   },

   props: {
      activeOrder: Number,
      isFeed: Boolean,
      isGameBlock: Boolean,
      saved: Boolean,
      reset: Boolean
   },

   computed: {
      ...mapState([
         'currActiveBlockRecid',
         'currActiveChannelRecid'
      ]),
      ...mapState('program_block', [
         'blockChannels',
         'blockCategories'
      ])
   },

   components: {
      ProgramBlockDisplayAssets,

      CategoryChecks,
      ChannelChecks 
   },

   methods: {
      updateExp(expDate) {
         self.expDate = expDate;
      },

      addChannel(recid) {
         this.newChannels.push(recid);
      },

      deleteChannel(recid) {
         var index = this.deleteChannels.indexOf(recid);
         if (index > -1) {
            this.deleteChannels.splice(index, 1);
         }
      }
   },

   created() {
      let self = this;
      this.$on('changeExp', (exp) => {
         self.expDate = exp;
      });

      if (this.expDate != '' && this.expDate != undefined) {
         this.expDate += ' UTC';
      }
   }
}
</script>

<style lang="scss" scoped>

#block_content_wrapper {
   display: flex;
   margin-bottom: 45px;
   
   &.active {
      display: flex;
   }
}

.block-right-col {
   width: 24%;
   >div:not(:last-child) {
      margin-bottom: 20px;
   }
}

</style>



